/**
 * Shared constants for the Windows page
 */

// Duration units options
export const DURATION_UNITS = [
  { value: "", label: "" },
  { value: "Days", label: "Days" },
  { value: "Weeks", label: "Weeks" },
  { value: "Months", label: "Months" },
  { value: "Years", label: "Years" },
];

// Window start date options
export const WINDOW_START_DATES = [
  { value: 0, label: "Super Premium EHVL Start Date" },
  { value: 1, label: "Premium EHVL Start Date" },
  { value: 2, label: "New Release EHVL Start Date" },
  { value: 3, label: "New to Catalog EHVL Start Date" },
  { value: 4, label: "Catalog EHVL Start Date" },
  { value: 5, label: "TVOD Super Premium Start Date" },
  { value: 6, label: "TVOD Premium Start Date" },
  { value: 7, label: "TVOD Current Start Date" },
  { value: 8, label: "TVOD Library Start Date" },
  { value: 9, label: "TPR Release Start Date" },
];

// Use pricing tier from options
export const USE_PRICING_TIER_FROM = [
  {
    value: "Super_Premium_EHVL_Start_Date",
    label: "Super Premium EHVL Start Date",
  },
  { value: "Premium_EHVL_Start_Date", label: "Premium EHVL Start Date" },
  {
    value: "New_Release_EHVL_Start_Date",
    label: "New Release EHVL Start Date",
  },
  {
    value: "New_to_Catalog_EHVL_Start_Date",
    label: "New to Catalog EHVL Start Date",
  },
  { value: "Catalog_EHVL_Start_Date", label: "Catalog EHVL Start Date" },
  {
    value: "TVOD_Super_Premium_Start_Date",
    label: "TVOD Super Premium Start Date",
  },
  { value: "TVOD_Premium_Start_Date", label: "TVOD Premium Start Date" },
  { value: "TVOD_Current_Start_Date", label: "TVOD Current Start Date" },
  { value: "TVOD_Library_Start_Date", label: "TVOD Library Start Date" },
  { value: "TPR_Release_Start_date", label: "TPR Release Start Date" },
  { value: "NextWindow", label: "Next Window" },
];

// Status options for forms
export const STATUS_OPTIONS = [
  { value: "ACTIVE", label: "Active" },
  { value: "INACTIVE", label: "Inactive" },
];

// Status colors
export const STATUS_COLORS = {
  green: "#4caf50",
  orange: "#ffa500",
  red: "#f44336",
  gray: "#9e9e9e",
};
